import React from 'react';
import propTypes from 'prop-types';
import Rating from './Rating';
import Button from './buttons';

const OtherTools = (props) => {
  const { node, editor, showRatings, isFocused } = props;
  const { type } = node;
  return (
    <>
      {
        {
          skill_title: showRatings && (
            <Rating
              node={node}
              editor={editor}
              isFocused={isFocused}
              key="skill"
            />
          ),
          language: showRatings && (
            <Rating
              node={node}
              editor={editor}
              isFocused={isFocused}
              key="language"
            />
          ),
          publication: (
            <Button
              node={node}
              editor={editor}
              isFocused={isFocused}
              key="publication"
            />
          ),
        }[type]
      }
    </>
  );
};

OtherTools.propTypes = {
  node: propTypes.objectOf(propTypes.object).isRequired,
  editor: propTypes.shape({
    resolveController: propTypes.func,
  }).isRequired,
};

export default OtherTools;
